import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AztecScannerAction} from '../../../../enums/next/aztec-scanner-action.enum';
import {TranslationContainerComponent} from '../../../abstract/translation-container.component';

@Component({
  selector: 'app-next-aztec-scanner-introduction',
  templateUrl: './next-aztec-scanner-introduction.component.html',
  styleUrls: []
})
export class NextAztecScannerIntroductionComponent extends TranslationContainerComponent {

  @Output() action: EventEmitter<AztecScannerAction> = new EventEmitter<AztecScannerAction>();

  constructor() {
    super('AZTEC_SCANNER.INTRODUCTION');
  }

  scan() {
    this.action.emit(AztecScannerAction.SCAN);
  }

  cancel() {
    this.action.emit(AztecScannerAction.CLOSE_APP);
  }

}
